import ApiHelper from "../../../../Helpers/ApiHelper";
import { folderEnum } from "../../../../Helpers/EnumHelper";

export default function InfoSection({ imageName }) {
  let background1 = {
    position: "relative",
    height: "1123px",
    left: 0,
    top: 0,
    width: "792px",
    zIndex: "-100",
  };

  return (
    <img
      style={background1}
      crossOrigin="anonymous"
      src={ApiHelper.cloudFrontURL + folderEnum.info + imageName}
      alt="Info"
    />
  );
}
